import React from 'react'
import { Loader } from '../Loader/Loader'
import { motion } from "framer-motion";
import { Grid } from "antd";

const { useBreakpoint } = Grid;
export const Tutorial = ({ loader, setCollapsed, setOpen }) => {
    const screens = useBreakpoint()

    return (
        <>
            {loader ?
                <Loader /> :
                <>
                    {screens.lg && <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.3 }}

                    >
                        <div className='display-5 p-20 trad-pos'>
                            <div className='side-title'>
                                Tutorial
                            </div>
                            <div className='cursor nonea3' onClick={() => setCollapsed(true)} id='cs'>
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z" fill="#82858E" stroke="#82858E" stroke-width="1.5294" />
                                </svg>
                            </div>
                        </div>
                    </motion.div>}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.3 }}

                    >
                        <div className=' leader-rank v2 cursor' id='cs'>
                            <div className='display-1'>
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M36 18C36 27.941 27.941 36 18 36C8.05887 36 0 27.941 0 18C0 8.05887 8.05887 0 18 0C27.941 0 36 8.05887 36 18ZM18 10.35C16.8817 10.35 15.975 11.2566 15.975 12.375C15.975 13.1206 15.3706 13.725 14.625 13.725C13.8794 13.725 13.275 13.1206 13.275 12.375C13.275 9.76545 15.3905 7.65 18 7.65C20.6095 7.65 22.725 9.76545 22.725 12.375C22.725 13.6545 22.2147 14.8176 21.3894 15.6672C21.2233 15.838 21.0649 15.9964 20.9137 16.1474C20.5252 16.5355 20.1848 16.8755 19.8862 17.2593C19.492 17.7658 19.35 18.1382 19.35 18.45V19.8C19.35 20.5456 18.7456 21.15 18 21.15C17.2544 21.15 16.65 20.5456 16.65 19.8V18.45C16.65 17.2706 17.199 16.3159 17.7556 15.601C18.1672 15.0719 18.6847 14.5553 19.1048 14.1362C19.2316 14.0098 19.3493 13.8922 19.4526 13.7858C19.8083 13.4198 20.025 12.9241 20.025 12.375C20.025 11.2566 19.1183 10.35 18 10.35ZM18 27C18.9941 27 19.8 26.1941 19.8 25.2C19.8 24.2059 18.9941 23.4 18 23.4C17.0059 23.4 16.2 24.2059 16.2 25.2C16.2 26.1941 17.0059 27 18 27Z" fill="#8F929B" />
                                </svg>

                                <div className='tut-head'>
                                    How to trade?
                                    <div className='tut-desc mt-10'>
                                        Binary Options
                                    </div>
                                </div>
                            </div>

                        </div>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.3 }}

                    >
                        <div className=' leader-rank v2 cursor' onClick={() => { setOpen(true); }} id='cs'>
                            <div className='display-1'>
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M36 18C36 27.941 27.941 36 18 36C8.05887 36 0 27.941 0 18C0 8.05887 8.05887 0 18 0C27.941 0 36 8.05887 36 18ZM18 10.35C16.8817 10.35 15.975 11.2566 15.975 12.375C15.975 13.1206 15.3706 13.725 14.625 13.725C13.8794 13.725 13.275 13.1206 13.275 12.375C13.275 9.76545 15.3905 7.65 18 7.65C20.6095 7.65 22.725 9.76545 22.725 12.375C22.725 13.6545 22.2147 14.8176 21.3894 15.6672C21.2233 15.838 21.0649 15.9964 20.9137 16.1474C20.5252 16.5355 20.1848 16.8755 19.8862 17.2593C19.492 17.7658 19.35 18.1382 19.35 18.45V19.8C19.35 20.5456 18.7456 21.15 18 21.15C17.2544 21.15 16.65 20.5456 16.65 19.8V18.45C16.65 17.2706 17.199 16.3159 17.7556 15.601C18.1672 15.0719 18.6847 14.5553 19.1048 14.1362C19.2316 14.0098 19.3493 13.8922 19.4526 13.7858C19.8083 13.4198 20.025 12.9241 20.025 12.375C20.025 11.2566 19.1183 10.35 18 10.35ZM18 27C18.9941 27 19.8 26.1941 19.8 25.2C19.8 24.2059 18.9941 23.4 18 23.4C17.0059 23.4 16.2 24.2059 16.2 25.2C16.2 26.1941 17.0059 27 18 27Z" fill="#8F929B" />
                                </svg>

                                <div className='tut-head'>
                                    Interface guide
                                    <div className='tut-desc mt-10'>
                                        Quick introduction
                                    </div>
                                </div>
                            </div>

                        </div>
                    </motion.div>
                </>}
        </>
    )
}
